import React, { useEffect } from 'react';
import { Modal } from 'antd';
import {
  getTpcorrespondentByTpid,
  GetTPStatusByTpidParams,
} from 'services/thirdParty';
import { useQuery } from 'react-query';
import { isEmpty } from 'lodash';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';

export type CorrespondantsModalProps = {
  record?: any;
  onClose?: any;
  visible: boolean;
  refresh: boolean;
  params: GetTPStatusByTpidParams;
};

const CorrespondantsModal = ({
  onClose,
  visible = false,
  params,
  refresh,
  ...otherProps
}: CorrespondantsModalProps) => {
  const { data,refetch } = useQuery(
    ['getTpcorrespondentByTpid', params],
    () => getTpcorrespondentByTpid(params).then((res) => res.list || []),
    { enabled: !isEmpty(params) || undefined }
  );

  useEffect(() => {
   if(refresh)
   refetch()
  }, [refresh])
  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'username',
      dataIndex: 'username',
      width: 100,
    },
   
  
  
    {
      comcode: 'startdate',
      dataIndex: 'startdate',
      width: 100,
    },
    {
      comcode: 'enddate',
      dataIndex: 'enddate',
      width: 100,
    },
    {
      comcode: 'statusdate',
      dataIndex: 'statusdate',
      width: 100,
    },
    {
      comcode: 'tpcorrespondentstatuslabel',
      dataIndex: 'tpcorrespondentstatuslabel',
      width: 100,
    },
  ];

  return (
    <Modal
      visible={visible}
      title=""
      width="1200px"
      style={{ top: 200 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
      }}
    >
      <DataGrid
        rowKey={(record) => record.taskid}
        dataSource={data}
        columns={columns}
        {...otherProps}
        
        
      />
    </Modal>
  );
};

export default CorrespondantsModal;
